var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 151,
    viewBox: "0 0 132 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6387 4.53817C87.6387 4.53817 60.8849 -1.26279 46.9997 4.47098C46.9997 4.47098 14.035 5.81484 10.438 30.9449C10.438 30.9449 19.7879 47.5863 25.6525 48.6166C31.5171 49.6357 29.8639 54.6975 29.8639 54.6975L35.6614 66.2435L37.9626 92.023L29.8639 89.0106L25.9764 90.22L26.4791 108.317L29.0707 111.419L56.5954 113.491L60.8961 108.306H70.7375L75.7978 111.755L100.239 111.375L106.059 97.1521L107.031 86.8268L108.897 82.4817L109.578 65.1236H103.903L99.3903 72.8171L95.9609 75.964V65.1124L101.803 51.2707L122.123 30.5305C122.123 30.5305 115.108 8.0098 87.6164 4.51578L87.6387 4.53817Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6611 66.2435C35.6611 66.2435 35.9739 111.755 47.8149 111.767C49.658 111.767 54.9976 111.767 55.8354 111.767C60.058 111.811 60.8958 108.541 60.8958 104.241V78.0806",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8227 94.554C36.8227 94.554 31.6171 89.1114 31.606 89.1002C29.7516 87.1628 26.8137 87.5996 25.9759 90.2089C25.4733 91.7767 25.6967 99.4143 25.6855 101.408C25.652 104.946 25.5626 109.247 29.0702 111.419C30.2767 112.158 33.4715 111.968 35.5492 111.968C39.4478 111.968 43.3576 111.968 47.2561 111.968",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7954 111.307C85.1699 111.61 84.522 111.766 83.8182 111.766C81.975 111.766 76.6354 111.766 75.7976 111.766C71.5751 111.811 70.7373 108.541 70.7373 104.241V78.0806",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9718 66.2435C95.9718 66.2435 95.8713 81.653 93.4473 94.5316",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4024 96.637C95.4024 96.637 88.3872 89.1115 88.376 89.1003C86.5217 87.1629 83.5838 87.5996 82.746 90.2089C82.2433 91.7768 82.4667 99.4143 82.4555 101.408C82.422 104.947 82.3326 109.247 85.8402 111.419C87.0467 112.159 90.2415 111.968 92.3193 111.968C93.6486 111.968 94.9779 111.968 96.3072 111.968C96.9439 111.968 97.5807 111.991 98.2174 111.968C100.854 111.89 102.272 109.572 103.244 107.433C105.97 101.397 106.45 93.5798 105.813 86.9501C105.233 80.9923 102.406 72.75 96.553 71.619",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.239 72.2684C100.239 72.2684 101.96 71.3053 102.887 67.8337C103.825 64.3173 108.852 64.2277 109.88 67.7105C111.22 72.2684 111.142 78.5733 107.031 86.838",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.896 108.306H70.7374",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8446 1.8729C65.8446 1.8729 52.7078 1.08898 46.9996 4.47101C46.4746 4.78458 44.6761 4.48221 44.0505 4.53821C41.3919 4.73979 38.7668 5.27733 36.2199 6.05004C27.2833 8.73775 19.5085 14.3819 13.4651 21.426C9.9352 25.5471 8.52769 29.9258 12.4933 34.3942L17.1626 40.0831C20.6367 44.3051 28.2216 54.496 34.2873 47.6647C34.2873 47.6647 41.3361 41.427 44.5532 31.0121",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8638 51.2931C29.8638 51.2931 31.1596 68.7184 50.1051 71.3277",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5408 45.6154C52.6322 45.6154 54.3276 43.9157 54.3276 41.819C54.3276 39.7223 52.6322 38.0226 50.5408 38.0226C48.4493 38.0226 46.7539 39.7223 46.7539 41.819C46.7539 43.9157 48.4493 45.6154 50.5408 45.6154Z",
    fill: "#DBDBDB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4593 51.4723L61.566 48.5718C60.4825 47.4856 61.2533 45.6154 62.7836 45.6154H68.8829C70.4244 45.6154 71.1952 47.4856 70.1005 48.5718L67.2073 51.4723C66.4476 52.2338 65.2077 52.2338 64.4481 51.4723H64.4593Z",
    fill: "#DBDBDB",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5947 55.1903C56.5947 55.1903 59.8566 61.2488 65.2967 57.1389V52.5362",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8447 1.8729C65.8447 1.8729 78.9815 1.08898 84.6897 4.47101C85.2147 4.78458 87.0132 4.48221 87.6388 4.53821C90.2974 4.73979 92.9225 5.27733 95.4694 6.05004C104.406 8.73775 112.181 14.3819 118.224 21.426C121.754 25.5471 123.162 29.9258 119.196 34.3942C117.643 36.2867 116.079 38.1905 114.527 40.0831C111.053 44.3051 103.468 54.496 97.402 47.6647C97.402 47.6647 90.3533 41.427 87.1361 31.0121",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.815 51.2931C101.815 51.2931 100.519 68.7184 81.5732 71.3277",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1487 45.6154C83.2401 45.6154 84.9356 43.9157 84.9356 41.819C84.9356 39.7223 83.2401 38.0226 81.1487 38.0226C79.0573 38.0226 77.3618 39.7223 77.3618 41.819C77.3618 43.9157 79.0573 45.6154 81.1487 45.6154Z",
    fill: "#DBDBDB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0936 55.1903C75.0936 55.1903 71.8317 61.2488 66.3916 57.1389V52.5362",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800781,
    y: 109.476,
    width: 130.62,
    height: 41.3172,
    rx: 4,
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1851 119.794V132.224H57.7197V135.271H55.1851V140.152H51.9225V135.271H42.3774V132.251C43.9593 130.184 45.5142 128.108 47.0421 126.023C48.5701 123.938 50.125 121.861 51.7068 119.794H55.1851ZM51.9225 132.278V125.996C51.9225 125.87 51.9225 125.645 51.9225 125.322C51.9405 124.998 51.9585 124.657 51.9765 124.297L46.0445 132.278H51.9225Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4045 130.148C73.4045 131.928 73.2157 133.474 72.8382 134.786C72.4608 136.08 71.9305 137.159 71.2474 138.022C70.5823 138.866 69.7914 139.496 68.8746 139.909C67.9578 140.322 66.9602 140.529 65.8817 140.529C64.8391 140.529 63.8594 140.322 62.9426 139.909C62.0438 139.496 61.2529 138.866 60.5698 138.022C59.9047 137.159 59.3834 136.08 59.0059 134.786C58.6285 133.474 58.4397 131.928 58.4397 130.148C58.4397 128.351 58.6285 126.805 59.0059 125.51C59.3834 124.198 59.9047 123.12 60.5698 122.275C61.2529 121.412 62.0438 120.774 62.9426 120.36C63.8594 119.947 64.8391 119.74 65.8817 119.74C66.9602 119.74 67.9578 119.947 68.8746 120.36C69.7914 120.774 70.5823 121.412 71.2474 122.275C71.9305 123.12 72.4608 124.198 72.8382 125.51C73.2157 126.805 73.4045 128.351 73.4045 130.148ZM69.6296 130.148C69.6296 128.71 69.5217 127.524 69.306 126.589C69.1083 125.636 68.8387 124.89 68.4971 124.351C68.1556 123.794 67.7511 123.407 67.2838 123.192C66.8344 122.958 66.367 122.841 65.8817 122.841C65.4143 122.841 64.9559 122.958 64.5065 123.192C64.0751 123.407 63.6886 123.794 63.3471 124.351C63.0055 124.89 62.7269 125.636 62.5112 126.589C62.3135 127.524 62.2146 128.71 62.2146 130.148C62.2146 131.568 62.3135 132.746 62.5112 133.68C62.7269 134.615 63.0055 135.361 63.3471 135.918C63.6886 136.476 64.0751 136.862 64.5065 137.078C64.9559 137.294 65.4143 137.401 65.8817 137.401C66.367 137.401 66.8344 137.294 67.2838 137.078C67.7511 136.862 68.1556 136.476 68.4971 135.918C68.8387 135.361 69.1083 134.615 69.306 133.68C69.5217 132.746 69.6296 131.568 69.6296 130.148Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3097 119.794V132.224H89.8442V135.271H87.3097V140.152H84.0471V135.271H74.502V132.251C76.0838 130.184 77.6387 128.108 79.1667 126.023C80.6946 123.938 82.2495 121.861 83.8314 119.794H87.3097ZM84.0471 132.278V125.996C84.0471 125.87 84.0471 125.645 84.0471 125.322C84.0651 124.998 84.083 124.657 84.101 124.297L78.169 132.278H84.0471Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7207 119.114C27.5803 120.411 27.7628 123.004 29.6159 123.004C31.469 123.004 31.7217 120.411 31.5111 119.114",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.031 122.356C104.891 123.652 105.073 126.245 106.926 126.245C108.78 126.245 109.032 123.652 108.822 122.356",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9409 126.245C19.8005 127.542 19.983 130.135 21.8361 130.135C23.6892 130.135 23.9419 127.542 23.7313 126.245",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon404);
export default __webpack_public_path__ + "static/media/icon-404.b3cd53a49af6acadd4d02a8520cfe76e.svg";
export { ForwardRef as ReactComponent };